import React from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import MenuItem from 'components/Menu/MenuItem';
// @ts-ignore
const MenuDeleteItem = React.forwardRef((props, ref) => {
    return React.createElement(MenuItem, Object.assign({ ref: ref, icon: React.createElement(DeleteIcon, null), text: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" }, props));
});
export default React.memo(MenuDeleteItem);
